export default "{\n    \"title\": \"Edit Preventative Maintenance\",\n    \"name\": \"Name\",\n    \"submitLabel\": \"Save\"\n}\n"